import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  VALIDATE_COUPON_REQUEST,
  VALIDATE_COUPON_SUCCESS,
  VALIDATE_COUPON_FAILURE,
  CLEAR_COUPON,
  SET_CART_ITEMS,
  UPDATE_CART_TOTALS,
  PROCESS_STRIPE_PAYMENT_REQUEST,
  PROCESS_STRIPE_PAYMENT_SUCCESS,
  PROCESS_STRIPE_PAYMENT_FAILURE,
  UPDATE_CART_DETAILS,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  error: "",
  loading: false,
  message: '',
  coupon: null,
  cartItems: [],
  subtotal: 0,
  discount: 0,
  total: 0,
  isPurchasing: false,
  purchaseError: null,
  purchaseSuccess: false,
  stripePaymentLoading: false,
  stripePaymentError: null,
  paymentIntent: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_START: {
      return {...state, error: '', message: '', loading: true};
    }
    case FETCH_SUCCESS: {
      return {...state, error: '', message: '', loading: false};
    }
    case SHOW_MESSAGE: {
      return {...state, error: '', message: action.payload, loading: false};
    }
    case FETCH_ERROR: {
      return {...state, loading: false, error: action.payload, message: ''};
    }
    case HIDE_MESSAGE: {
      return {...state, loading: false, error: '', message: ''};
    }
    case VALIDATE_COUPON_REQUEST: {
      return {...state, loading: true, error: ''};
    }
    case VALIDATE_COUPON_SUCCESS: {
      return {
        ...state,
        loading: false,
        coupon: action.payload,
        error: '',
        //discount: action.payload.discountAmount
      };
    }
    case VALIDATE_COUPON_FAILURE: {
      return {
        ...state,
        loading: false,
        coupon: null,
        error: action.payload,
      };
    }
    case CLEAR_COUPON: {
      return {
        ...state,
        coupon: null,
        error: ''
      };
    }
    case SET_CART_ITEMS: {
      const subtotal = action.payload.reduce((sum, item) => sum + parseFloat(item.price), 0);
      return {
        ...state,
        cartItems: action.payload,
        subtotal,
        total: subtotal - state.discount
      };
    }
    case UPDATE_CART_TOTALS: {
      const couponDiscount = state.coupon ? parseFloat(state.coupon.discount) || 0 : 0;
      const subtotal = parseFloat(state.subtotal) || 0;
      const discount = parseFloat(state.discount) || 0;
      return {
        ...state,
        total: Math.max(0, subtotal - discount - couponDiscount).toFixed(2)
      };
    }
    case PROCESS_STRIPE_PAYMENT_REQUEST:
      return {
        ...state,
        stripePaymentLoading: true,
        stripePaymentError: null,
        paymentIntent: null
      };
    case PROCESS_STRIPE_PAYMENT_SUCCESS:
      return {
        ...state,
        stripePaymentLoading: false,
        paymentIntent: action.payload,
        stripePaymentError: null
      };
    case PROCESS_STRIPE_PAYMENT_FAILURE:
      return {
        ...state,
        stripePaymentLoading: false,
        stripePaymentError: action.payload
      };
 
    case UPDATE_CART_DETAILS:
      return {
        ...state,
        paymentIntent: null,
        subtotal: action.payload.subtotal || state.subtotal,
        discount: action.payload.discount || state.discount,
        total: action.payload.total || state.total
      };
    default:
      return state;
  }
};
